'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Reinitialization', ['AVRO.Common.Moment']).factory('ReinitializationService', require('./services/ReinitializationService'));